module.exports = __webpack_public_path__ + "img/avatarFrame2.712f51a2.png";